import { render, staticRenderFns } from "./list-from.vue?vue&type=template&id=33b677d6&scoped=true"
import script from "./list-from.vue?vue&type=script&lang=js"
export * from "./list-from.vue?vue&type=script&lang=js"
import style0 from "./list-from.vue?vue&type=style&index=0&id=33b677d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b677d6",
  null
  
)

export default component.exports